// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/research_papers.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/research_papers.proto.
 */
export const file_guardianai_v1_admin_research_papers: GenFile = /*@__PURE__*/
  fileDesc("CilndWFyZGlhbmFpL3YxL2FkbWluL3Jlc2VhcmNoX3BhcGVycy5wcm90bxITZ3VhcmRpYW5haS52MS5hZG1pbiKsAQoNUmVzZWFyY2hQYXBlchIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRILCgN1cmwYBCABKAkSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiSgoVUmVzZWFyY2hQYXBlclJlc3BvbnNlEjEKBXBhcGVyGAEgASgLMiIuZ3VhcmRpYW5haS52MS5hZG1pbi5SZXNlYXJjaFBhcGVyIk0KGkNyZWF0ZVJlc2VhcmNoUGFwZXJSZXF1ZXN0Eg0KBXRpdGxlGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEgsKA3VybBgDIAEoCSIlChdHZXRSZXNlYXJjaFBhcGVyUmVxdWVzdBIKCgJpZBgBIAEoCSI4ChlMaXN0UmVzZWFyY2hQYXBlcnNSZXF1ZXN0EgwKBHBhZ2UYASABKAUSDQoFbGltaXQYAiABKAUiZQoaTGlzdFJlc2VhcmNoUGFwZXJzUmVzcG9uc2USMgoGcGFwZXJzGAEgAygLMiIuZ3VhcmRpYW5haS52MS5hZG1pbi5SZXNlYXJjaFBhcGVyEhMKC3RvdGFsX2NvdW50GAIgASgFIooBChpVcGRhdGVSZXNlYXJjaFBhcGVyUmVxdWVzdBIKCgJpZBgBIAEoCRISCgV0aXRsZRgCIAEoCUgAiAEBEhgKC2Rlc2NyaXB0aW9uGAMgASgJSAGIAQESEAoDdXJsGAQgASgJSAKIAQFCCAoGX3RpdGxlQg4KDF9kZXNjcmlwdGlvbkIGCgRfdXJsIigKGkRlbGV0ZVJlc2VhcmNoUGFwZXJSZXF1ZXN0EgoKAmlkGAEgASgJMsMEChRSZXNlYXJjaFBhcGVyU2VydmljZRJyChNDcmVhdGVSZXNlYXJjaFBhcGVyEi8uZ3VhcmRpYW5haS52MS5hZG1pbi5DcmVhdGVSZXNlYXJjaFBhcGVyUmVxdWVzdBoqLmd1YXJkaWFuYWkudjEuYWRtaW4uUmVzZWFyY2hQYXBlclJlc3BvbnNlEmwKEEdldFJlc2VhcmNoUGFwZXISLC5ndWFyZGlhbmFpLnYxLmFkbWluLkdldFJlc2VhcmNoUGFwZXJSZXF1ZXN0GiouZ3VhcmRpYW5haS52MS5hZG1pbi5SZXNlYXJjaFBhcGVyUmVzcG9uc2USdQoSTGlzdFJlc2VhcmNoUGFwZXJzEi4uZ3VhcmRpYW5haS52MS5hZG1pbi5MaXN0UmVzZWFyY2hQYXBlcnNSZXF1ZXN0Gi8uZ3VhcmRpYW5haS52MS5hZG1pbi5MaXN0UmVzZWFyY2hQYXBlcnNSZXNwb25zZRJyChNVcGRhdGVSZXNlYXJjaFBhcGVyEi8uZ3VhcmRpYW5haS52MS5hZG1pbi5VcGRhdGVSZXNlYXJjaFBhcGVyUmVxdWVzdBoqLmd1YXJkaWFuYWkudjEuYWRtaW4uUmVzZWFyY2hQYXBlclJlc3BvbnNlEl4KE0RlbGV0ZVJlc2VhcmNoUGFwZXISLy5ndWFyZGlhbmFpLnYxLmFkbWluLkRlbGV0ZVJlc2VhcmNoUGFwZXJSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5Qh1aG2d1YXJkaWFuYWkvdjEvYWRtaW47YWRtaW52MWIGcHJvdG8z", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message guardianai.v1.admin.ResearchPaper
 */
export type ResearchPaper = Message<"guardianai.v1.admin.ResearchPaper"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.ResearchPaper
 */
export type ResearchPaperJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string url = 4;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.ResearchPaper.
 * Use `create(ResearchPaperSchema)` to create a new message.
 */
export const ResearchPaperSchema: GenMessage<ResearchPaper, {jsonType: ResearchPaperJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 0);

/**
 * @generated from message guardianai.v1.admin.ResearchPaperResponse
 */
export type ResearchPaperResponse = Message<"guardianai.v1.admin.ResearchPaperResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.ResearchPaper paper = 1;
   */
  paper?: ResearchPaper;
};

/**
 * @generated from message guardianai.v1.admin.ResearchPaperResponse
 */
export type ResearchPaperResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.ResearchPaper paper = 1;
   */
  paper?: ResearchPaperJson;
};

/**
 * Describes the message guardianai.v1.admin.ResearchPaperResponse.
 * Use `create(ResearchPaperResponseSchema)` to create a new message.
 */
export const ResearchPaperResponseSchema: GenMessage<ResearchPaperResponse, {jsonType: ResearchPaperResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 1);

/**
 * @generated from message guardianai.v1.admin.CreateResearchPaperRequest
 */
export type CreateResearchPaperRequest = Message<"guardianai.v1.admin.CreateResearchPaperRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * @generated from message guardianai.v1.admin.CreateResearchPaperRequest
 */
export type CreateResearchPaperRequestJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string url = 3;
   */
  url?: string;
};

/**
 * Describes the message guardianai.v1.admin.CreateResearchPaperRequest.
 * Use `create(CreateResearchPaperRequestSchema)` to create a new message.
 */
export const CreateResearchPaperRequestSchema: GenMessage<CreateResearchPaperRequest, {jsonType: CreateResearchPaperRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 2);

/**
 * @generated from message guardianai.v1.admin.GetResearchPaperRequest
 */
export type GetResearchPaperRequest = Message<"guardianai.v1.admin.GetResearchPaperRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.GetResearchPaperRequest
 */
export type GetResearchPaperRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetResearchPaperRequest.
 * Use `create(GetResearchPaperRequestSchema)` to create a new message.
 */
export const GetResearchPaperRequestSchema: GenMessage<GetResearchPaperRequest, {jsonType: GetResearchPaperRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 3);

/**
 * @generated from message guardianai.v1.admin.ListResearchPapersRequest
 */
export type ListResearchPapersRequest = Message<"guardianai.v1.admin.ListResearchPapersRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.admin.ListResearchPapersRequest
 */
export type ListResearchPapersRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListResearchPapersRequest.
 * Use `create(ListResearchPapersRequestSchema)` to create a new message.
 */
export const ListResearchPapersRequestSchema: GenMessage<ListResearchPapersRequest, {jsonType: ListResearchPapersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 4);

/**
 * @generated from message guardianai.v1.admin.ListResearchPapersResponse
 */
export type ListResearchPapersResponse = Message<"guardianai.v1.admin.ListResearchPapersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.ResearchPaper papers = 1;
   */
  papers: ResearchPaper[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListResearchPapersResponse
 */
export type ListResearchPapersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.ResearchPaper papers = 1;
   */
  papers?: ResearchPaperJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListResearchPapersResponse.
 * Use `create(ListResearchPapersResponseSchema)` to create a new message.
 */
export const ListResearchPapersResponseSchema: GenMessage<ListResearchPapersResponse, {jsonType: ListResearchPapersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 5);

/**
 * @generated from message guardianai.v1.admin.UpdateResearchPaperRequest
 */
export type UpdateResearchPaperRequest = Message<"guardianai.v1.admin.UpdateResearchPaperRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string url = 4;
   */
  url?: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateResearchPaperRequest
 */
export type UpdateResearchPaperRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string url = 4;
   */
  url?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateResearchPaperRequest.
 * Use `create(UpdateResearchPaperRequestSchema)` to create a new message.
 */
export const UpdateResearchPaperRequestSchema: GenMessage<UpdateResearchPaperRequest, {jsonType: UpdateResearchPaperRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 6);

/**
 * @generated from message guardianai.v1.admin.DeleteResearchPaperRequest
 */
export type DeleteResearchPaperRequest = Message<"guardianai.v1.admin.DeleteResearchPaperRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteResearchPaperRequest
 */
export type DeleteResearchPaperRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteResearchPaperRequest.
 * Use `create(DeleteResearchPaperRequestSchema)` to create a new message.
 */
export const DeleteResearchPaperRequestSchema: GenMessage<DeleteResearchPaperRequest, {jsonType: DeleteResearchPaperRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_research_papers, 7);

/**
 * @generated from service guardianai.v1.admin.ResearchPaperService
 */
export const ResearchPaperService: GenService<{
  /**
   * @generated from rpc guardianai.v1.admin.ResearchPaperService.CreateResearchPaper
   */
  createResearchPaper: {
    methodKind: "unary";
    input: typeof CreateResearchPaperRequestSchema;
    output: typeof ResearchPaperResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.ResearchPaperService.GetResearchPaper
   */
  getResearchPaper: {
    methodKind: "unary";
    input: typeof GetResearchPaperRequestSchema;
    output: typeof ResearchPaperResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.ResearchPaperService.ListResearchPapers
   */
  listResearchPapers: {
    methodKind: "unary";
    input: typeof ListResearchPapersRequestSchema;
    output: typeof ListResearchPapersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.ResearchPaperService.UpdateResearchPaper
   */
  updateResearchPaper: {
    methodKind: "unary";
    input: typeof UpdateResearchPaperRequestSchema;
    output: typeof ResearchPaperResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.ResearchPaperService.DeleteResearchPaper
   */
  deleteResearchPaper: {
    methodKind: "unary";
    input: typeof DeleteResearchPaperRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_research_papers, 0);

